module.exports = __webpack_public_path__ + "static/media/zw.48d58160.svg";